import { ColoursObj, Icon, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { CardText } from '../../componentCards/subComponents/cardText'
import { PageDivider } from '../../componentCards/subComponents/divider'
import { ExpandableSection } from '../../componentCards/subComponents/expendableSection'
import { RowInfo } from '../../componentCards/subComponents/rowInfo'
import { RowInfoFiles } from '../../componentCards/subComponents/rowInfoFiles'
import { RowInfoNotes } from '../../componentCards/subComponents/rowInfoNotes'
import { RowInfoWeb } from '../../componentCards/subComponents/rowInfoWeb'
interface IAdditionalInfoProps {
    airline?: string
    notes?: string
    website?: string
    files?: string[]
}
export const AdditionalInfo = ({
    airline,
    notes,
    website,
    files,
}: IAdditionalInfoProps) => {
    if (!airline && !notes && !website && (!files || files.length === 0)) {
        return null
    }
    return (
        <Stack paddingTop="8px" gap={'8px'}>
            <PageDivider />
            <ExpandableSection
                mid={<Icon name="Info" />}
                end={
                    <Typography>
                        {cardTranslation('Additional Information')}
                    </Typography>
                }
                arrowPosition="right"
            >
                <Stack gap={'8px'}>
                    {airline && (
                        <RowInfo
                            start={
                                <Icon
                                    name={'Airline'}
                                    iconColour={ColoursObj.coreBrights.primary}
                                />
                            }
                            under={<CardText>{airline}</CardText>}
                            middle={
                                <Typography variant="bodyBold">
                                    {cardTranslation('Airline')}
                                </Typography>
                            }
                        />
                    )}
                    {notes && <RowInfoNotes type="page" notes={notes} />}
                    {website && <RowInfoWeb type="page" website={website} />}
                    {files && files.length > 0 && (
                        <RowInfoFiles type="page" files={files} />
                    )}
                </Stack>
            </ExpandableSection>
        </Stack>
    )
}
